import enTranslations from '../locales/en.json';
import zhTranslations from '../locales/zh.json';

const translations = {
  en: enTranslations,
  zh: zhTranslations
};

export const getTranslation = (key, language = 'en') => {
  try {
    return key.split('.').reduce((obj, k) => obj && obj[k], translations[language]) || key;
  } catch (error) {
    console.warn(`Translation key "${key}" not found for language "${language}"`);
    return key;
  }
};

export const getAvailableLanguages = () => {
  return Object.keys(translations);
};

export default {
  getTranslation,
  getAvailableLanguages
};
